import { Flex } from '@phi/components/layout';
import { Button } from '@phi/components';
import { run_consistency_checks } from '@frontend/utility';
import { h } from 'vue';

export function CheckNow() {
    return h(Flex, { direction: 'row' }, () => [
        h(Button, {
            variant: 'primary',
            onClick: () =>  run_consistency_checks(false, true),
        }, () => 'Check Now'),

        h(Button, {
            variant: 'primary',
            onClick: () => run_consistency_checks(true, true),
        }, () => 'Fix discontinuities'),
    ]);
}
